import React, { createContext, useContext, useRef, useState } from 'react';
import AudioEditor from './AudioEditor';


export const AudioEditorContext = createContext();

const AudioEditorProvider = (props) => {
    // Refs
    const containerRef = useRef(null);
    const wavesurferRef = useRef(null);
    const regionsPluginRef = useRef(null);
    const firstDoubleClickTimeRef = useRef(null);
    const tempRegionRef = useRef(null);


    // States
    const [isLoading, setIsLoading] = useState(true);
    const [audioDuration, setAudioDuration] = useState(null);
    const [isWaitingForSecondClick, setIsWaitingForSecondClick] = useState(false);
    const [regionsList, setRegionsList] = useState([]);
    const [isNetoAudio, setIsNetoAudio] = useState(false)

    // States for MUI Menu
    const [menuPosition, setMenuPosition] = useState(null);
    const [selectedRegion, setSelectedRegion] = useState(null);

    const audioRate = props.rate || 1

    const contextValue = {
        refs: {
            containerRef,
            wavesurferRef,
            regionsPluginRef,
            firstDoubleClickTimeRef,
            tempRegionRef,
        },
        state: {
            isLoading, setIsLoading,
            audioDuration, setAudioDuration,
            isWaitingForSecondClick, setIsWaitingForSecondClick,
            regionsList, setRegionsList,
            menuPosition, setMenuPosition,
            selectedRegion, setSelectedRegion,
            isNetoAudio, setIsNetoAudio,
            audioRate,
            isAudioMarkingMode: props.isAudioMarkingMode
        }
    };

    return (
        <AudioEditorContext.Provider value={contextValue}>
            <AudioEditor {...props} />
        </AudioEditorContext.Provider>
    );
};

export default AudioEditorProvider